<div class="root-body"
     [ngClass]="{
    'root-body-sidebar-slim': configService.config.menuMode === 'sidebar' || configService.config.menuMode === 'slim',
    'root-body-sidebar-static': configService.config.menuMode === 'sidebar' && configService.config.sidebarStatic,
    'root-body-horizontal': configService.config.menuMode === 'horizontal'}">

    <div class="root-body-inner">
        <div class="pml-header">
            <div class="pml-header-title">{{groupName}}</div>
        </div>
        <div style="font-weight: 500; font-size: 16px; margin-top: 10px;">Group Store Hours</div>
        <div style="margin-top: 2px;">Setting Group Store Hours will automatically over-ride individual store settings</div>

        <p-scrollPanel [style]="{width:'100%', height: configService.config.menuMode === 'horizontal' ? 'calc(100vh - 332px)' : 'calc(100vh - 270px)'}"
                       [styleClass]="'app-scrollpanel'">
            <partner-mart-locations-hours [operationHours]="operationHours"
                                          [specialHours]="specialHours"></partner-mart-locations-hours>
        </p-scrollPanel>

        <div class="flex justify-content-end" style="margin: 20px;">
            <button pButton label="Save" (click)="onSaveHoursClick()"></button>
        </div>
    </div>
</div>

<p-toast position="top-right"></p-toast>
